import { DateTime } from 'luxon';
import { observable, computed, action } from 'mobx';

import { getDate, getLocalDateTime } from 'helpers/datetime';
import { BaseFormModel, isRequired } from 'stores/BaseForm';
import { FeedbackDishGroupsReportReqParams } from 'http/Api/Feedback/types';
import { DishGroupManagement } from 'stores/Menu/types';
import { sortByAccessor } from 'helpers/accessors';
import Log from 'helpers/log';
import { PromiseService } from 'services/PromiseService';
import httpFacade from 'http/httpFacade';
import RootStore from 'stores/RootStore';

class FeedbackDishGroupsReportForm extends BaseFormModel {
  @observable
  @isRequired()
  period: [DateTime, DateTime] = [getLocalDateTime(), getLocalDateTime()];

  @observable
  dishGroupId = '';

  @observable private _dishGroups: DishGroupManagement[] = [];
  @observable private _promiseService = new PromiseService();

  @action
  async init() {
    try {
      const { data } = await this._promiseService.add(
        httpFacade.menu.fetchCategories,
      );

      this._dishGroups = data;
    } catch (error) {
      Log.info(error);
    }
  }

  @computed
  get requestParams(): FeedbackDishGroupsReportReqParams {
    return {
      startDate: this.startDateParam,
      endDate: this.endDateParam,
      dishGroupId: this.dishGroupId,
    };
  }

  @computed
  get startDateParam() {
    return getDate(this.period[0].toJSDate());
  }

  @computed
  get endDateParam() {
    return getDate(this.period[1].toJSDate());
  }

  @computed
  get dishGroupsValues() {
    return [
      {
        value: '',
        label: RootStore.localization.formatMessage('title.all.categories'),
      },
      ...this._dishGroups
        .slice()
        .sort(sortByAccessor({ accessor: 'title', desc: false }))
        .map(dishGroup => ({
          value: dishGroup.id,
          label: dishGroup.title,
        })),
    ];
  }

  @computed
  get loading() {
    return this._promiseService.isPending || !this._promiseService.isCompleted;
  }
}

export default FeedbackDishGroupsReportForm;
